// TODO: "Tak urcite radsi prepsat na "normalni" composable"
export default () => ([
  { name: 'CZ', mobileName: 'Čeština', code: 'cs' },
  { name: 'EN', mobileName: 'English', code: 'en' },
])
